export default {
  label: '技术总监',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '负责公司整体技术方向的规划和实施',
          id: '0-1-1',
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定公司技术发展战略',
          id: '0-2-1',
        },
        {
          label: '领导技术研发团队，推动技术创新',
          id: '0-2-2',
        },
        {
          label: '管理技术资源，优化技术流程',
          id: '0-2-3',
        },
        {
          label: '解决重大技术问题，提升公司技术水平',
          id: '0-2-4',
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备全面的技术视野和战略规划能力',
          id: '0-3-1',
        },
        {
          label: '具备较强的领导力和团队管理能力',
          id: '0-3-2',
        },
        {
          label: '熟悉行业发展趋势和技术前沿',
          id: '0-3-3',
        },
        {
          label: '具备较强的沟通能力和协调能力',
          id: '0-3-4',
        }
      ]
    }
  ]
}